"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Loader;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Loader(_ref) {
  var withContainer = _ref.withContainer,
      loaderClass = _ref.loaderClass;

  var LoaderContent = /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "loading ".concat(loaderClass),
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: "circle",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "3.6"
  })));

  return withContainer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "loaderContainer"
  }, LoaderContent) : LoaderContent;
}

Loader.defaultProps = {
  withContainer: false,
  loaderClass: ''
};
Loader.propTypes = {
  withContainer: _propTypes["default"].bool,
  loaderClass: _propTypes["default"].string
};